import getProp from '@f/get-prop'

const key = (workspaceSlug, sourceMetadataSlug) => `${workspaceSlug}-${sourceMetadataSlug}`

export const getSourceSettingsBaseData = (state, workspaceSlug, sourceMetadataSlug) =>
  getProp(`sourceSettingsBaseData.${key(workspaceSlug, sourceMetadataSlug)}.data`, state)

export const isRequestingSourceSettingsBaseData = (state, workspaceSlug, sourceMetadataSlug) =>
  getProp(`sourceSettingsBaseData.${key(workspaceSlug, sourceMetadataSlug)}.isRequesting`, state)

export const didFailToRequestSourceSettingsBaseData = (state, workspaceSlug, sourceMetadataSlug) =>
  getProp(`sourceSettingsBaseData.${key(workspaceSlug, sourceMetadataSlug)}.didRequestFail`, state)



// WEBPACK FOOTER //
// ./selectors/source-settings-base-data.js